import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function NewJoiners() {
  const [employees, setEmployees] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [instances, setInstances] = useState([]);
  const [picking, setPicking] = useState({ emp: "", tpl: "" });

  const load = async () => {
    const [e, t, i] = await Promise.all([
      api.get("/employees"),
      api.get("/onboarding/templates"),
      api.get("/onboarding/instances"),
    ]);
    setEmployees(e.data); setTemplates(t.data); setInstances(i.data);
  };
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!picking.emp || !picking.tpl) return toast.warning("Pick employee + template");
    await api.post(`/onboarding/instances?employee_id=${picking.emp}&template_id=${picking.tpl}`);
    toast.success("Onboarding started"); load();
  };

  const toggle = async (iid, item_id, status) => {
    await api.patch(`/onboarding/instances/${iid}/item`, { item_id, status });
    load();
  };

  const empMap = Object.fromEntries(employees.map((e) => [e.employee_id, e]));

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight mb-1">New joiners</h1>
      <p className="text-sm text-[#A1A1AA] mb-6">Active onboarding runs and what's blocking.</p>

      <div className="tt-card p-4 mb-6 flex gap-2 flex-wrap items-center">
        <select className="tt-input !w-auto" value={picking.emp} onChange={(e) => setPicking({ ...picking, emp: e.target.value })}>
          <option value="">— pick employee —</option>
          {employees.filter((e) => e.status !== "exited").map((e) => (
            <option key={e.employee_id} value={e.employee_id}>{e.display_name || e.legal_name} · {e.role_title}</option>
          ))}
        </select>
        <select className="tt-input !w-auto" value={picking.tpl} onChange={(e) => setPicking({ ...picking, tpl: e.target.value })}>
          <option value="">— pick template —</option>
          {templates.map((t) => <option key={t.template_id} value={t.template_id}>{t.name} ({t.kind})</option>)}
        </select>
        <button onClick={create} className="tt-btn-primary text-sm">Start onboarding</button>
      </div>

      {instances.length === 0 && <div className="text-sm text-[#71717A]">No active onboarding yet.</div>}
      <div className="space-y-4">
        {instances.map((inst) => {
          const emp = empMap[inst.employee_id];
          const done = inst.items.filter((i) => i.status === "done").length;
          const blocked = inst.items.filter((i) => i.status === "blocked").length;
          return (
            <div key={inst.instance_id} className="tt-card p-4">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <div className="font-medium">{emp ? (emp.display_name || emp.legal_name) : inst.employee_id}</div>
                  <div className="text-xs font-mono text-[#71717A]">{emp?.email} · {inst.kind}</div>
                </div>
                <div className="flex gap-2 items-center">
                  {blocked > 0 && <span className="tt-badge-warn">{blocked} blocked</span>}
                  <span className="font-mono text-xs text-[#A1A1AA]">{done}/{inst.items.length}</span>
                </div>
              </div>
              <div className="space-y-1">
                {inst.items.map((it) => (
                  <div key={it.item_id} className="flex items-center gap-3 py-1.5 border-b border-[#1E1E1E] last:border-0">
                    <input type="checkbox" checked={it.status === "done"} onChange={() => toggle(inst.instance_id, it.item_id, it.status === "done" ? "open" : "done")} className="accent-[#5B9BFF] h-4 w-4" />
                    <div className="flex-1 min-w-0 text-sm">
                      <span className={it.status === "done" ? "line-through text-[#71717A]" : ""}>{it.label}</span>
                      {it.tool && <span className="ml-2 tt-badge-neutral">{it.tool}</span>}
                    </div>
                    <div className="text-xs font-mono text-[#71717A]">{it.due_date}</div>
                    <button onClick={() => toggle(inst.instance_id, it.item_id, it.status === "blocked" ? "open" : "blocked")} className={`tt-btn-ghost text-xs ${it.status === "blocked" ? "text-[#F5A524]" : ""}`}>
                      {it.status === "blocked" ? "Unblock" : "Block"}
                    </button>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
